import 'whatwg-fetch';
import 'babel-polyfill';
import { getApiHost } from './utils/apiUtils';

function createFetchThatPrefixEndpoint(wrappedFetch: typeof fetch): typeof fetch {
  return async function prefixEndpointFetch(input: RequestInfo, init?: RequestInit) {
    if (typeof input === 'string' && input.startsWith('/')) {
      // Make every call to /__api__, so that it can be routed to the backend container
      input = `${getApiHost()}${input}`;
    }

    return wrappedFetch(input, init);
  };
}

// @ts-ignore
global.fetch = createFetchThatPrefixEndpoint(fetch);
